import React, { useReducer } from "react";
import { reducer, initialState } from "./reducer";

const contextName = "BusinessFixedAsset";

const StateContext = React.createContext();
const DispatchContext = React.createContext();

export function useBusinessFixedAssetState() {
  const context = React.useContext(StateContext);
  if (context === undefined) {
    throw new Error(
      `useBusinessFixedAssetState must be used within a ${contextName}Provider`
    );
  }

  return context;
}

export function useBusinessFixedAssetDispatch() {
  const context = React.useContext(DispatchContext);
  if (context === undefined) {
    throw new Error(
      `useBusinessFixedAssetDispatch must be used within a ${contextName}Provider`
    );
  }

  return context;
}

export const BusinessFixedAssetProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>
  );
};
